/**
 * The one label every cost-centre dropdown shows: "CODE / SHORT - Name".
 *
 * Nine screens used to build this text by hand (two spellings: three of them
 * never showed the short label). One home, so a change to how a cost centre
 * reads in a picker is made once.
 *
 * IMT only (divergence 07): a cost centre made automatically for a new
 * delivery can be used straight away but reads "(not yet approved)" until a
 * Cost Centre Approver approves it.
 */
export const NOT_YET_APPROVED_SUFFIX = ' (not yet approved)';

export function costCentreLabel(cc) {
  if (!cc) return '';
  const short = cc.short_name ? ` / ${cc.short_name}` : '';
  const waiting = cc.approval_status === 'pending' ? NOT_YET_APPROVED_SUFFIX : '';
  return `${cc.cost_center_code}${short} - ${cc.cost_center_name}${waiting}`;
}

export default costCentreLabel;
